import { RewardLogsQueryParams } from '@adminServices';
import { CreateRewardLogDto, RewardLog } from '@klubovna/api-client';
import { createAction, props } from '@ngrx/store';
import { PaginationMetadata } from '@shared';

export const ADMIN_REWARD_LOGS_ID = '[RewardLogs admin]';

export const loadRewardLogs = createAction(
  ADMIN_REWARD_LOGS_ID + ' Load RewardLogs',
  props<{ params?: RewardLogsQueryParams }>(),
);

export const loadRewardLogsSuccess = createAction(
  ADMIN_REWARD_LOGS_ID + ' Load RewardLogs Success',
  props<{ rewardLogs: RewardLog[]; pagination: PaginationMetadata }>(),
);

export const loadRewardLogsFailure = createAction(
  ADMIN_REWARD_LOGS_ID + ' Load RewardLogs Failure',
  props<{ error: string }>(),
);

export const createRewardLog = createAction(
  ADMIN_REWARD_LOGS_ID + ' Create RewardLog',
  props<{ rewardLogData: CreateRewardLogDto }>(),
);

export const createRewardLogSuccess = createAction(
  ADMIN_REWARD_LOGS_ID + ' Create RewardLog Success',
  props<{ rewardLog: RewardLog }>(),
);

export const createRewardLogFailure = createAction(
  ADMIN_REWARD_LOGS_ID + ' Create RewardLog Failure',
  props<{ error: string }>(),
);

export const deleteRewardLog = createAction(
  ADMIN_REWARD_LOGS_ID + ' Delete RewardLog',
  props<{ id: string }>(),
);

export const deleteRewardLogSuccess = createAction(
  ADMIN_REWARD_LOGS_ID + ' Delete RewardLog Success',
  props<{ id: string }>(),
);

export const deleteRewardLogFailure = createAction(
  ADMIN_REWARD_LOGS_ID + ' Delete RewardLog Failure',
  props<{ error: string }>(),
);

